import InputNumber from "global/InputNumber/InputNumber";
import InputSelect from "global/InputSelect/InputSelect";
import InputText from "global/InputText/InputText";
import Modal from "global/Modal/Modal";
import MultiLineText from "global/MultiLineText/MultiLineText";
import Radio from "global/Radio/Radio";
import { useFetchOptions } from "global/hooks/useFetchOptions";
import QrScanner from "global/scanner";
import { convertScannedItem } from "pages/order-receipt/view/action/consignments";
import { useEffect, useState } from "react";
import { BsUpcScan } from "react-icons/bs";
import { useSelector } from "react-redux";
import { getUrls } from "services/api.enums";
import ProductIdsValidation from "./ProductIdsValidation";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { getAPI } from "services/CRUDServices";
import { MdWarningAmber } from "react-icons/md";

const ConsignmentInfo = ({ formik, submitAndNew, mainWight,freeBardoce,setFreeeBarcode }) => {
  const { withCod, withPostPaid } = useSelector((state: any) => state.userInfo);
  const [openScan, setOpenScan] = useState(false);
  const { values, setFieldValue, handleChange, setValues, errors, touched } =
    formik;

  const { dataOptions: packageLists } = useFetchOptions(
    getUrls.typesOfPackageList
  );
  const { dataOptions: contentType } = useFetchOptions(
    getUrls.getContentTypes2
  );
  const { currenthub } = useSelector((state: any) => state.userInfo);
  const RadioWrapper = ({ label, children }) => {
    return (
      <div className="flex gap-x-10 flex-col gap-y-4 relative  Max-md:my-2">
        <div className=" absolute top-[-12px] right-4 z-50 bg-white">
          {label}
        </div>
        <div className="flex gap-x-20 bg-white h-[2.5rem]  rounded-lg autocompleteWrapper justify-center">
          {children}
        </div>
      </div>
    );
  };

  function convertRespons(option) {
    return option.map((pack) => ({ ...pack, id: pack.code, text: pack.name }));
  }

  const filteredPackages = (packageLists?.options || []).filter((item) => {
    const codeNumber = Number(item.code);

    if (values.consignmentType?.id === 1) {
      // بسته → سایز 1 تا 10
      return codeNumber >= 1 && codeNumber <= 10;
    }

    if (values.consignmentType?.id === 0) {
      // پاکت → بزرگتر از 10
      return codeNumber > 10;
    }

    return true;
  });

  function handleCHangePack(value: any) {
    const findPackInfo = packageLists.options.find(
      (item) => item.code === value.id
    );

    setValues({
      ...values,
      width: findPackInfo.width,
      height: findPackInfo.height,
      length: findPackInfo.length,
      packageId: value,
    });
  }

  function onScan(decodedText: string) {
    const convertScan = convertScannedItem(decodedText);
    setOpenScan(false);
    setFieldValue("cprNumber", convertScan);
    submitAndNew();
  }

  async function getFreeBarcode() {
    try {
      setFreeeBarcode({ ...freeBardoce, loading: true });
      const res = await getAPI(
        `/consignment-api/label/getFreeLabelFromHub/${currenthub?.id}`
      );
      setFreeeBarcode({ data: res.data.serialNumber, loading: false });
      setFieldValue("cprNumber", res.data.serialNumber);
    } catch {
      setFreeeBarcode({ ...freeBardoce, loading: false });
    }
  }
  const isDisablePostBack = [335, 342].includes(
    values?.receiver?.receiverCityId?.id
  );

  useEffect(() => {
    if (isDisablePostBack) setFieldValue("postBack", false);
  }, [values?.receiver?.receiverCityId?.id]);

  const isJof = values.contentType?.id === 1 && values.consignmentType?.id === 0;

  return (
    <>
      <h1 className=" text-lg font-semibold">اطلاعات مرسوله</h1>
      <div className="grid grid-cols-3 Max-md:grid-cols-1  max-w-6xl Max-md:flex-col gap-x-4 gap-y-4 my-8">
        <RadioWrapper label={"نوع مرسوله"}>
          <Radio
            title="بسته"
            name={`consignmentType`}
            values={values.consignmentType.id}
            checked={1}
            handleChange={() => {
              setFieldValue("consignmentType", { id: 1, text: "بسته" });
            }}
          />
          <Radio
            title="پاکت"
            name={`consignmentType`}
            values={values.consignmentType.id}
            checked={0}
            handleChange={() => {
              setFieldValue("consignmentType", { id: 0, text: "پاکت" });
            }}
          />
        </RadioWrapper>

        <div className=" relative Max-md:mt-8">
          <div className=" absolute top-[-3rem] left-0">
            {isJof ? (
              <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-600 px-3 py-2 rounded-lg mt-2 w-fit">
                <MdWarningAmber size={20} color="red" />
                <p className="text-sm font-semibold">این مرسوله جوف است</p>
              </div>
            ) : (
              ""
            )}
          </div>
          <InputSelect
            label="نوع محتوا"
            important
            name="contentType"
            handleChange={setFieldValue}
            values={values.contentType}
            error={touched.contentType && errors.contentType}
            options={contentType.options}
            wrapperClassName="w-full"
            positionFixed
          />
        </div>
        <div className="flex  gap-2 w-full  ">
          <InputText
            classNames="bg-white"
            wrapperClassName="w-full"
            important
            leftIcon={
              <div className="flex gap-3 items-center">
                <button type="button" onClick={() => setOpenScan(!openScan)}>
                  <BsUpcScan size={30} className="text-[#EAB308] " />
                </button>
              </div>
            }
            placeholder="شماره مرسوله  را وارد کنید یا اسکن کنید"
            handleChange={handleChange}
            name="cprNumber"
            values={values.cprNumber}
            error={touched.cprNumber && errors.cprNumber}
            maxLength={13}
            readOnly={!!freeBardoce?.data}
          />

          <SimpleButton
            text={"ثبت بارکد"}
            handelClick={getFreeBarcode}
            loading={freeBardoce?.loading}
            className=" border border-tomato bg-white w-[8rem] "
            disabled={!!freeBardoce?.data }
          />
        </div>

        {/* <ScanConsignments
          simpleMode={true}
          value={values.cprNumber}
          handleChange={handleChange}
          handleScan={(cleanedText) => {
            formik.setFieldValue("cprNumber", cleanedText);
          }}
          name="cprNumber"
          error={touched.cprNumber && errors.cprNumber}
          // maxLength={13}
          classNames="bg-white"
          wrapperClassName="w-full"
          important
          palceholder="شماره مرسوله را وارد کنید یا اسکن کنید"
    
          showAddButton={false} 
        /> */}

        <InputText
          classNames="bg-white"
          label="وزن (کیلوگرم)"
          name="weight"
          handleChange={handleChange}
          values={values.weight}
          important
          error={touched.weight && errors.weight}
          wrapperClassName="w-full"
          maxLength={6}
          readOnly={values.consignmentId && mainWight > 15}
        />
        <InputSelect
          label="سایز کارتن"
          important
          name="packageId"
          handleChange={(_, value) => handleCHangePack(value)}
          values={values.packageId}
          error={touched.packageId && errors.packageId}
          options={convertRespons(filteredPackages) || []}
          wrapperClassName="w-full"
          positionFixed
        />
        <InputText
          classNames="bg-white"
          label="طول (سانتی متر)"
          name="length"
          handleChange={handleChange}
          values={values.length}
          important
          error={touched.length && errors.length}
          wrapperClassName="w-full"
          maxLength={2}
        />
        <InputText
          classNames="bg-white"
          label="عرض (سانتی متر)"
          name="width"
          handleChange={handleChange}
          values={values.width}
          important
          error={touched.width && errors.width}
          wrapperClassName="w-full"
          maxLength={2}
        />
        <InputText
          classNames="bg-white"
          label="ارتفاع (سانتی متر)"
          name="height"
          handleChange={handleChange}
          values={values.height}
          important
          error={touched.height && errors.height}
          wrapperClassName="w-full"
          maxLength={2}
        />

        <RadioWrapper label={"پس کرایه"}>
          <Radio
            title="دارد"
            name={`postBack`}
            values={values.postBack}
            checked={true}
            handleChange={setFieldValue}
            isDisabled={!withPostPaid || isDisablePostBack}
            // isDisabled={
            //   currenthub?.id === 46 ? false : values.thirdPartyDelivery
            // }
          />
          <Radio
            title="ندارد"
            name={`postBack`}
            values={values.postBack}
            checked={false}
            handleChange={setFieldValue}
            isDisabled={!withPostPaid || isDisablePostBack}
            // isDisabled={
            //   currenthub?.id === 46 ? false : values.thirdPartyDelivery
            // }
          />
        </RadioWrapper>
        <RadioWrapper label={"بسته بندی"}>
          <Radio
            title="دارد"
            name={`needToPack`}
            values={values.needToPack}
            checked={true}
            handleChange={setFieldValue}
            isDisabled
          />
          <Radio
            title="ندارد"
            name={`needToPack`}
            values={values.needToPack}
            checked={false}
            handleChange={setFieldValue}
            isDisabled
          />
        </RadioWrapper>
        <RadioWrapper label={"تعهد جبران خسارت"}>
          <Radio
            title="عمومی"
            name={`insurance`}
            values={values.insurance?.id}
            checked={0}
            handleChange={() => {
              setFieldValue("insurance", { id: 0, text: "" });
              // setFieldValue("value", "")
            }}
          />
          <Radio
            title="ارزش اظهاری"
            name={`insurance`}
            values={values.insurance?.id}
            checked={1}
            handleChange={() => {
              setFieldValue("insurance", { id: 1, text: "" });
            }}
          />
        </RadioWrapper>
        {values.insurance.id === 1 ? (
          <InputNumber
            label="ارزش (ریال)"
            name="value"
            handleChange={setFieldValue}
            values={values.value}
            important
            error={touched.value && errors.value}
            wrapperClassName="w-full"
            readOnly={values.costOfGoods}
          />
        ) : null}
        <RadioWrapper label={"COD"}>
          <Radio
            title="دارد"
            name={`cod`}
            values={values.cod}
            checked={true}
            handleChange={setFieldValue}
            isDisabled={!withCod}
          />
          <Radio
            title="ندارد"
            name={`cod`}
            values={values.cod}
            checked={false}
            handleChange={(name, value) => {
              setFieldValue(name, value);
              setFieldValue("costOfGoods", "");
              setFieldValue("value", "");
            }}
            isDisabled={!withCod}
          />
        </RadioWrapper>
        {values.cod ? (
          <InputNumber
            className=""
            label="مبلغ (ریال)"
            name="costOfGoods"
            handleChange={(name, value) => {
              setFieldValue(name, value);
              setFieldValue("value", value);
            }}
            values={values.costOfGoods}
            important
            error={touched.costOfGoods && errors.costOfGoods}
            wrapperClassName="w-full mt-2"
          />
        ) : null}
        <InputNumber
          // classNames="bg-white"
          label=" خدمات جانبی (ریال)"
          name="extraCosts"
          handleChange={setFieldValue}
          values={values.extraCosts}
          // important

          error={touched.extraCosts && errors.extraCosts}
          wrapperClassName="w-full mt-2"
        />

        <MultiLineText
          label=" توضیحات"
          values={values.messageForDriver}
          name="messageForDriver"
          handleChange={handleChange}
          error={touched.messageForDriver && errors.messageForDriver}
          classNames="bg-white"
          wrapperClassName="col-span-2  Max-md:col-span-1 relative mt-2"
          row={2}
        />

        <ProductIdsValidation
          formik={formik}
          nationalId={values?.sender?.nationalCode}
        />
      </div>

      <Modal visible={openScan} setVisible={setOpenScan} title="اسکن">
        {openScan && <QrScanner onSuccess={onScan} />}
      </Modal>
    </>
  );
};

export default ConsignmentInfo;
